import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState({ status: "loading", user: null });

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setState({ status: "loading", user: null });
      return;
    }
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setState({ status: "authed", user: data });
      } catch {
        setState({ status: "anon", user: null });
      }
    })();
  }, []);

  if (state.status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500">Loading…</div>
    );
  }
  if (state.status === "anon") return <Navigate to="/login" replace />;
  return children;
}
